<nz-modal
  [(nzVisible)]="showModalExpertNotAvailable"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30 modal-add-group'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}"
  (nzOnCancel)="onEmitCloseModal()">
  <ng-template #modalTitle>
    <div class="container-steps-modal" [@fadeInAnimation]>
      <h2 class="text-title-md-bold title-modal">
        <i nz-icon nzType="info-circle" nzTheme="outline"></i>
        No puedes agendar citas
      </h2>
    </div>
  </ng-template>

  <ng-template #modalContent>
    <div class="container-modal" [@fadeInAnimation]>
      <p class="text-info">La opción para agendar citas se encuentra deshabilidata.
        <span class="text-link" (click)="onGotoProfile()">quiero ir a configuración</span>
      </p>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <div class="container-footer-modal" [@fadeInAnimation]>
      <button
        class="mr-xxs"
        (click)="onEmitCloseModal()"
        nz-button nzType="cancel">
        <i nz-icon nzType="close-circle" nzTheme="outline"></i>
        CANCELAR</button>
    </div>
  </ng-template>
</nz-modal>
